import { useEffect } from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import MediaCoverage from "./components/MediaCoverage";
import Services from "./components/Services";
import MediaPartners from "./components/MediaPartners";
import Footer from "./components/Footer";

function App() {
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  return (
    <div className="App bg-[#0a1628] min-h-screen">
      <Header />
      <Hero />
      <About />
      <MediaCoverage />
      <Services />
      <MediaPartners />
      <Footer />
    </div>
  );
}

export default App;